export default {
  zh: {
    'dialCodeErrorMsg': '该区号不存在',
    'dialCode': '区号'
  },
  en: {
    'dialCodeErrorMsg': 'The area code is invalid.',
    'dialCode': 'Area Code'
  }
}



// WEBPACK FOOTER //
// ./src/components/callingCode/lang.js